import React from 'react';

import { useContext } from 'react';

import { ClientContext } from '../../store/client-context.jsx';



import {
    Nav,
    NavLogo,
    NavLink,
    Bars,
    NavMenu,
    NavBtn,
    NavBtnLink,
} from "./DashbarElements";


const Dashbar = ({ open, setOpen, id,...props }) => {

    const { slctdCase } = useContext(ClientContext);

    console.log ( 'slctdCase=', slctdCase);

    return (
        <>
            <Nav>
            <NavLogo to="/">
                {slctdCase[0]}
            </NavLogo>
            <Bars />
            <NavMenu>
                <NavLink to="/" activeStyle>
                    Home
                </NavLink>
                <NavLink to="/about" activeStyle>
                    About
                </NavLink>    
                <NavLink to="/pricing" activeStyle>
                    Pricing    
                </NavLink>
                <NavLink to="/contact" activeStyle>
                    Contact
                </NavLink>
            </NavMenu> 
           </Nav> 
        </>
    );
};
export default Dashbar;
